import { useState } from 'react'
import { Tabs } from 'antd'
import { PageHeader } from '@components'
import TCCCRobotCallRecord from './components/TCCCRobotCallRecord'
import QidianRobotCallRecord from './components/QidianRobotCallRecord'
import { moduleId } from '@configs'
import store, { sessionStore } from '@store'
import { useShallow } from 'zustand/shallow'

const isQidianIncluded = [moduleId.MID_LONG_TAIL_ID]

export default function RobotCallRecord () {
  const { isPermissableBelongModule } = sessionStore(
    useShallow(s => ({
      isPermissableBelongModule: s.isPermissableBelongModule
    }))
  )

  const [activeTab, setActiveTab] = useState('tccc')

  const tabItems = [
    {
      key: 'tccc',
      label: 'TCCC机器人通话记录',
      children: <TCCCRobotCallRecord />,
    },
    ...(isPermissableBelongModule(isQidianIncluded)
      ? [
          {
            key: 'qidian',
            label: '企点机器人通话记录',
            children: <QidianRobotCallRecord />,
          },
        ]
      : []),
  ]

  return (
    <>
      <PageHeader title="机器人通话记录"/>
      <Tabs
        tabBarStyle={{
          background: '#fff',
          marginBottom: 0,
          marginTop: '20px',
          paddingLeft: '20px',
        }}
        activeKey={activeTab}
        items={tabItems}
        onChange={setActiveTab}
      />
    </>
  )
}
